export const styleInputVariantInfo1 = {
  fontSize: '14px',
  color: 'AFB3BA',
}